// Library Methods
import { ReactNode } from "react";

// Components
import Box from "@mui/material/Box";

// A module's far and near cards side by side at equal widths (stacked on narrow screens), so the
// two distances read straight across from each other.
const DistanceRow = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      gap: "8px",
      "& > *": { flex: "1 1 0", minWidth: 0 },
    }}
  >
    {children}
  </Box>
);

export default DistanceRow;
